import { Grid, MenuItem } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown, FormikTextField } from "../../../../../../shared/components/forms/Formik"

export function MerchantMainInfo({ readonly = false }) {
    return (
        <>
            <LocalizedStrict
                id="create-or-edit-supplier-admin-merchant-field-caseNumber"
                attrs={{ label: true, placeholder: true, helperText: !readonly }}
            >
                <FormikTextField
                    disabled={readonly}
                    name="caseNumber"
                    label="Reg no."
                    placeholder="Enter a Reg no."
                    fullWidth
                    helperText={readonly ? "" : "Helper text"}
                />
            </LocalizedStrict>
            <LocalizedStrict
                id="create-or-edit-supplier-admin-merchant-field-name"
                attrs={{ label: true, placeholder: true }}
            >
                <FormikTextField disabled={readonly} name="name" label="Name" placeholder="Merchant name" fullWidth />
            </LocalizedStrict>
            <Grid container flexWrap="nowrap" gap={4}>
                <Grid item xs={8}>
                    <LocalizedStrict
                        id="create-or-edit-supplier-admin-merchant-field-street"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField
                            disabled={readonly}
                            name="address.street"
                            label="Street"
                            placeholder="Enter street"
                            fullWidth
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={4}>
                    <LocalizedStrict
                        id="create-or-edit-supplier-admin-merchant-field-streetNumber"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField
                            disabled={readonly}
                            name="address.streetNumber"
                            label="Street no"
                            placeholder="Enter street no"
                            fullWidth
                        />
                    </LocalizedStrict>
                </Grid>
            </Grid>
            <Grid container flexWrap="nowrap" gap={4}>
                <Grid item xs={4}>
                    <LocalizedStrict
                        id="create-or-edit-supplier-admin-merchant-field-postalCode"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField
                            disabled={readonly}
                            name="address.postalCode"
                            label="Postal code"
                            placeholder="Enter postal code"
                            fullWidth
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={8}>
                    <LocalizedStrict
                        id="create-or-edit-supplier-admin-merchant-field-city"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikTextField
                            disabled={readonly}
                            name="address.city"
                            label="City"
                            placeholder="Enter city"
                            fullWidth
                        />
                    </LocalizedStrict>
                </Grid>
            </Grid>
            <LocalizedStrict id="create-or-edit-supplier-admin-merchant-field-country" attrs={{ label: true }}>
                <FormikDropdown
                    disabled={readonly}
                    defaultValue="DK"
                    name="address.country.code"
                    label="Country"
                    fullWidth
                >
                    <MenuItem value="DK">
                        <LocalizedStrict id="create-or-edit-supplier-admin-merchant-country-denmark-item">
                            <span>Denmark</span>
                        </LocalizedStrict>
                    </MenuItem>
                </FormikDropdown>
            </LocalizedStrict>
        </>
    )
}
